import { BASIC_INPUT_STUDENTS_REQUEST } from "../../../enums/Request/request.types";

export const addInputToStudentActon = ({ input, index, field }) => {
    return {
        type: BASIC_INPUT_STUDENTS_REQUEST,
        payload: { input, i: index, inputField: field },
    };
};
